var module = angular.module('octopusApp.environments');

module.controller('EnvironmentEditController', function ($scope, $stateParams, $q, busy, pageTitle, octopusRepository, $location, octoDialog){
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    $scope.environment = null;

    var environmentId = $stateParams["id"];

    if (environmentId) {
        isLoading.promise(octopusRepository.Environments.get(environmentId).then(function (result) {
            $scope.environment = result;
            pageTitle(result.Name + " settings");
        }));
    } else {
        $scope.environment = {};
        pageTitle("Create environment");
    }

    $scope.save = function() {
        isSaving.promise(octopusRepository.Environments.save($scope.environment).then(function (result) {
            $location.path("/environments");
        }));
    };

    var confirmDeletingEnvironmentWhichHasScopedVariables = function(success) {
        var allWarnings = [];
        var additionalWarnings = [];
        octopusRepository.Environments.variablesScopedOnlyToThisEnvironment($scope.environment)
            .then(function(response) {
                if (_.isEmpty(response.VariableMap) && 
                    !response.HasUnauthorizedProjectVariables && 
                    !response.HasUnauthorizedLibraryVariableSetVariables) {
                    var dlg = octoDialog.confirmDelete('environment', success);
                    dlg.then(function(result) {
                        if (result) {
                            $location.path("/environments");
                        }
                    });
                    return;
                }

                allWarnings.push(_.flatten(_.map(response.VariableMap, function(map, key) {
                    return _.map(map, function (value, name) {
                        var variableSuffix = value > 1 ? "s" : "";
                        return value + " variable" + variableSuffix + " in the <strong><em>" + name + "</em></strong> " + key.toLowerCase();
                    });
                })));

                var shownWarnings = _.take(_.flatten(_.reduce(allWarnings, function (memo, warning) { return warning; }, [])), 5);

                if (allWarnings[0].length > 5) {
                    additionalWarnings = _.rest(_.flatten(_.reduce(allWarnings, function (memo, line) { return line; }, [])), 5);
                }

                var error;
                if (response.HasUnauthorizedProjectVariables || response.HasUnauthorizedLibraryVariableSetVariables) {
                    error = { Errors: [] };
                    if (response.HasUnauthorizedProjectVariables) {
                        error.Errors.push("Variables exist in projects for which you do not have edit permissions");
                    }

                    if (response.HasUnauthorizedLibraryVariableSetVariables) {
                        error.Errors.push("Variables exist in library variable sets for which you do not have edit permissions");
                    }
                }
                var warningMessage = shownWarnings.length > 0 
                    ? "Deleting this environment will also delete <strong>ALL</strong> the variables that are scoped only to this environment in the following locations:<br/><br/><p class='text-left'>" + shownWarnings.join("<br/>") + "</p>" 
                    : "";

                octoDialog.asyncConfirm({
                    title: "Variables scoped only to this environment exist",
                    message: warningMessage,
                    additionalDetails: additionalWarnings,
                    executeButtonClass: "btn-warning",
                    executeButtonText: "Delete anyway",
                    error: error,
                    execute: function (dialog) {
                        dialog.busy.promise(success()).then(function() {
                            dialog.dismiss();
                            $location.path("/environments");
                        });
                    }
                });
            });
    };

    $scope.deleteEnvironment = function() {
        confirmDeletingEnvironmentWhichHasScopedVariables(function () {
            return octopusRepository.Environments.del($scope.environment);
        });
    };
});







//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/controllers/environment_edit_controller.js
// module id = 7995632996622994
// module chunks = 1